import { message } from "antd";
import { API_CENTER } from "../api/api";
import { Dayjs } from "dayjs";

interface DownloadAllDocumentsParams {
  applicationBankId: number;
  organizationName: string;
  organizationINN: string;
}

const downloadFile = (res: any, fileName: string) => {
  if (res.type !== "application/json") {
    const blob = new Blob([res], { type: res.type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}`;
    document.body.append(link);
    link.click();
    link.remove();
  }
};

const ApiStart = new API_CENTER();

export const applicationBankDocumentsApi = {
  // скачать все документы предложения
  downloadOfferDocuments: async ({
    organizationINN: organizationINN,
    organizationName: organizationName,
    applicationBankId,
  }: DownloadAllDocumentsParams) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/zip-offer`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(
        res,
        `Документы предложения заявки №${applicationBankId}-(${organizationName},ИНН:${organizationINN})`
      );
    } catch {
      message.error("Не удалось скачать документы");
    }
  },
  // скачать все документы заявки
  downloadAllDocuments: async ({
    organizationINN: organizationINN,
    organizationName: organizationName,
    applicationBankId,
  }: DownloadAllDocumentsParams) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/zip`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(
        res,
        `Документы заявки №${applicationBankId}-(${organizationName},ИНН:${organizationINN})`
      );
    } catch {
      message.error("Не удалось скачать документы");
    }
  },

  // скачать документ заявки
  downloadDocument: async ({
    applicationBankId,
    fileId,
    fileName,
  }: {
    applicationBankId: number;
    fileId: number;
    fileName: string;
  }) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/${fileId}`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(
        res,
        fileName.replace(".", `(Заявка-${applicationBankId}).`)
      );
    } catch {
      message.error("Не удалось скачать документ");
    }
  },

  // скачать файл подписи документа (.sig)
  downloadDocumentSignFile: async ({
    applicationBankId,
    fileId,
    fileName,
    signId,
  }: {
    applicationBankId: number;
    fileId: number;
    fileName: string;
    signId: number;
  }) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/${fileId}/sign/${signId}`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(
        res,
        fileName.replace(".", `(Заявка-${applicationBankId}).`)
      );
    } catch {
      message.error("Не удалось скачать документ");
    }
  },

  // скачать (сформировать) отчёт
  downloadReport: async ({
    startDate,
    endDate,
  }: {
    startDate: Dayjs;
    endDate: Dayjs;
  }) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/report?start_date=${startDate
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")}&end_date=${endDate
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")}`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(res, "Отчёт");
    } catch {
      message.error("Не удалось скачать документ");
    }
  },

  // скачать (сформировать) профсуждение
  downloadJudgment: async ({
    applicationBankId,
  }: {
    applicationBankId: number;
  }) => {
    try {
      const res = await ApiStart.configAxios(
        `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/judgment`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(res, `Профсуждение(Заявка-${applicationBankId})`);
    } catch {
      message.error("Не удалось скачать документ");
    }
  },

  // скачать анкету на случай если документ Анкеты не сгенерировался
  showAnketa: async ({ applicationBankId }: { applicationBankId: number }) => {
    try {
      const res = await ApiStart.configAxios(
        `/auth/sign/client-anketa/${applicationBankId}/show`,
        {
          responseType: "blob",
        },
        true
      );
      downloadFile(res, "Анкета");
    } catch {
      message.error("Не удалось скачать документ");
    }
  },
};
